module.exports = "<div><label style=visibility:hidden;height:0><l10n>Cabin class</l10n></label><div style=position:relative dropdown-kt details=cabin options=::options.cabinClasses model=params.CabinClass></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trains-base/templates/flights/form_options/trains-cabin-class-dropdown.html
// module id = 3686
// module chunks = 0